<mat-toolbar>
  @if (isHandset$ | async) {
    <button
      type="button"
      aria-label="Toggle sidenav"
      mat-icon-button
      (click)="toggleDrawer.emit()">
      <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
    </button>
    <span><mat-icon fontIcon="luggage"></mat-icon> Tourist</span>
  }
  <app-breadcrumb></app-breadcrumb>
  <span class="spacer"></span>
  <app-profile-menu></app-profile-menu>
</mat-toolbar>
